import React from 'react';

import useHpEventCta from '../../../hooks/useHpEventCta';
import { HpEventCtaVariants } from '../constants';

import styles from '../findAccommodations.scss';

const HpDualVariant = ({ surface, event }) => {
    const {
        eventCityName,
        handleCtaClick,
        handleSearchHotelsClick,
    } = useHpEventCta({ surface, event, variant: HpEventCtaVariants.HP_DUAL });

    return (
        <div
            className={styles.hpEventCtaContainer}
            data-testid="event-profile.find-accommodations.hp-dual"
        >
            <p
                className={styles.title}
                data-testid="event-profile.find-accommodations.hp-dual.title"
            >
                {eventCityName ? `Save on your stay in ${eventCityName}` : 'Save on your stay'}
            </p>
            <p
                className={styles.subtitle}
                data-testid="event-profile.find-accommodations.hp-dual.subtitle"
            >
                Search 1.4M hotels through our partner <strong>Hotel Planner</strong> where UTR users get discounted rates.
            </p>
            <button
                type="button"
                className={`btn btn-primary btn-small text-uppercase mt16 mb16 ${styles.button}`}
                onClick={handleSearchHotelsClick}
                data-testid="event-profile.find-accommodations.hp-dual.search-hotels-btn"
            >
                Search Hotels
            </button>
            <div
                className={styles.callout}
                data-testid="event-profile.find-accommodations.hp-dual.callout"
            >
                <p
                    className={styles.calloutHeading}
                    data-testid="event-profile.find-accommodations.hp-dual.callout-heading"
                >
                    Want to save more?
                </p>
                <p
                    className={styles.calloutBody}
                    data-testid="event-profile.find-accommodations.hp-dual.callout-body"
                >
                    Annual Power members get up to 60% off hotels worldwide, plus $250+ in annual travel benefits.
                </p>
                <button
                    type="button"
                    className={styles.calloutLink}
                    onClick={handleCtaClick}
                    data-testid="event-profile.find-accommodations.hp-dual.unlock-power-rates-link"
                >
                    Unlock Power Rates
                </button>
            </div>
        </div>
    );
};

export default HpDualVariant;
